import { defineComponent as r, createBlock as t, openBlock as n, unref as l, mergeProps as c, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconFire",
  __name: "IconFire",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const a = o;
    return (d, e) => (n(), t(l(m), c(a, { "view-box": "0 0 24 24" }), {
      default: p(() => e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M11.75 5.03V2.22L8.326 5.642c-1.94 1.94-3.617 4.482-4.255 7.016-.646 2.568-.23 5.214 2.16 7.075 1.599 1.245 3.587 2.043 5.753 2.047h.03c2.167-.004 4.155-.802 5.753-2.047 2.177-1.695 2.724-4.053 2.303-6.413-.414-2.322-1.76-4.685-3.418-6.62l-.518-.604-.572.553a2.25 2.25 0 0 1-3.813-1.619m3.593 14.46a8.587 8.587 0 0 0 1.502-.94c1.648-1.283 2.093-3.03 1.748-4.967-.317-1.778-1.304-3.678-2.63-5.358a3.751 3.751 0 0 1-5.642-2.456L9.389 6.703c-1.81 1.81-3.308 4.123-3.861 6.321-.545 2.165-.168 4.128 1.627 5.526a8.583 8.583 0 0 0 1.502.94 4.573 4.573 0 0 1-.406-1.888c0-1.212.636-2.24 1.294-3.043a16.966 16.966 0 0 1 1.03-1.124l.175-.178a17.48 17.48 0 0 0 .686-.72L12 11.89l.564.645a17.54 17.54 0 0 0 .686.72l.175.179a16.956 16.956 0 0 1 1.03 1.124c.658.804 1.295 1.831 1.295 3.043a4.573 4.573 0 0 1-.407 1.889m-3.334.79H11.99c-1.149-.006-2.241-1.106-2.241-2.678 0-.683.363-1.37.955-2.093a15.541 15.541 0 0 1 .94-1.023l.161-.165L12 14.125l.193.196a81.327 81.327 0 0 1 .162.165 15.57 15.57 0 0 1 .94 1.023c.591.723.955 1.41.955 2.093 0 1.572-1.093 2.672-2.241 2.678",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
